<template>
  <div class="dashboard">
    <h3>Elementary Cellular Automata</h3>
    <ECARuleViewer :rule="automaton.rule"
                   @ruleChanged="onRuleChanged"></ECARuleViewer>
    <ECACanvas :width="width"
               :height="height"
               ref="canvas"></ECACanvas>
    <el-button-group id="buttons">
      <el-button @click="run" :disabled="running"
                 :icon="running ? 'el-icon-loading' : 'el-icon-caret-right'">
        Run
      </el-button>
      <el-button @click="stop"
                 :disabled="!config.isInfinite || !running"
                 icon="el-icon-close">Stop</el-button>
      <el-button :disabled="running"
                 icon="el-icon-download"
                 @click="downloadPNG">
        Download PNG
      </el-button>
    </el-button-group>
    <el-form label-width="120px" id="form">
      <el-form-item label="Rule Number">
        <el-col :span="12">
          <el-input-number v-model="config.ruleNumber"
                           :min="0" :max="255"></el-input-number>
        </el-col>
      </el-form-item>
      <el-form-item label="Random">
        <el-col :span="5">
          <el-switch v-model="config.isRandom"
                     :disabled="running"
                     ></el-switch>
        </el-col>
      </el-form-item>
      <el-form-item label="Infinite Loop">
        <el-col :span="5">
          <el-switch v-model="config.isInfinite"
                     :disabled="running"></el-switch>
        </el-col>
      </el-form-item>
      <el-form-item label="Color">
        <el-col :span="5">
          <el-color-picker v-model="config.aliveColor"></el-color-picker>
        </el-col>
        <el-col :span="1">
          <el-color-picker v-model="config.deadColor"></el-color-picker>
        </el-col>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { ElementaryCellularAutomaton } from '@/ca'
import ECARuleViewer from '@/components/ECARuleViewer'
import ECACanvas from '@/components/ECACanvas'
export default {
  components: {
    ECARuleViewer,
    ECACanvas
  },
  data () {
    return {
      width: 600,
      height: 300,
      automaton: new ElementaryCellularAutomaton({ ruleNumber: 126, size: 600}),
      config: {
        ruleNumber: 126,
        isRandom: false,
        aliveColor: '#000',
        deadColor: '#f7f4e3',
        isInfinite: false
      },
      running: false
    }
  },
  provide () {
    return {
      automaton: this.automaton,
      config: this.config
    }
  },
  computed: {
    ruleNumber () {
      return this.config.ruleNumber
    },
    lattice () {
      return this.automaton.lattice
    },
    age () {
      return this.automaton.age
    }
  },
  watch: {
    ruleNumber () {
      this.automaton.setRule(this.ruleNumber)
    }
  },
  methods: {
    onRuleChanged (number) {
      this.automaton.setRule(number)
      this.config.ruleNumber = number
    },
    step () {
      this.automaton.oneStep()
    },
    run () {
      this.running = true
      this.automaton.initWorld({isRandom: this.config.isRandom})
      window.requestAnimationFrame(this.loop)
    },
    loop () {
      if (this.config.isInfinite) {
        if (this.running) {
          this.step()
          window.requestAnimationFrame(this.loop)
        }
      } else {
        if (this.age < this.height - 1) {
          this.step()
          window.requestAnimationFrame(this.loop)
        } else {
          this.running = false
        }
      }
    },
    stop () {
      this.running = false
    },
    downloadPNG () {
      let link = document.createElement('a')
      link.download = `eca-rule-${this.automaton.rule.number}.png`
      link.href = this.$refs.canvas.toDataURL('image/png')
      link.click()
    }
  }
}
</script>
<style scoped>
.dashboard {
  width: 600px;
  margin: 0 auto;
}
#form {
  margin: 20px auto;
}
#buttons {
  margin: 20px auto;
}
</style>
